<template>
    <v-dialog
            :model-value="dialog"
            @update:modelValue="$emit('update:modelValue', $event)"
            width="500">
        <v-card>
            <v-card-title
                    class="headline grey lighten-2"
                    primary-title
            >{{$t('gamification.delete_title_dialog')}}
            </v-card-title>
            <v-card-text class="pt-4 pb-1">
              {{$t('gamification.delete_warning_dialog')}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn color="light" @click="emitDialogClosed">{{$t('gamification.cancel')}}</v-btn>
                <v-btn color="red" dark :loading="loading" @click="method">{{$t('gamification.delete')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "DeleteDialog",
        data(){
            return{
            }
        },

        props: {
            method: Function,
            dialog: Boolean,
            loading: Boolean
        },

        methods: {
            emitDialogClosed(){
                this.$emit('childToParent');
            }
        }
    }
</script>

<style scoped>

</style>